<div class="input-group no-border mr-1 ml-1">
    <form [formGroup]="searchForm" autocomplete="off">
        <mat-form-field appearance="outline">
            <mat-label *ngIf="myplaceholder">{{myplaceholder}}</mat-label>
            <mat-select #filterby [placeholder]="myplaceholder" formControlName="filterbyformcontrol" multiple>
                <mat-select-trigger>
                    <!-- {{getFilterValuesDescription(filterby.value)}} -->
                    <span [innerHTML]="selectionDescription"></span>
                    <!-- <span *ngIf="filterby.value?.length > 1" class="example-additional-selection">
                        (+{{filterby.value.length - 1}} {{filterby.value?.length === 2 ? 'other' : 'others'}})
                    </span> -->
                </mat-select-trigger>
                <mat-option #allSelected (click)="toggleAllSelection()" [value]="includeAllItem" *ngIf="includeall">
                    {{includeAllItem.name}}
                </mat-option>
                <mat-option *ngFor="let item of mylist" [value]="getValue(item)"
                    (click)="toggleItem()">
                    {{item.name}}
                </mat-option>
            </mat-select>
        </mat-form-field>
    </form>
</div>